import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import WebHeader from "./components/WebHeader";
import WebFooter from "./components/WebFooter";
import Router from "./routes/Router";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
     <>
      <Router />
      <CookieBanner />
    </>
  );
}

export default App;
